const typeRoot = "root";
const typeFunction = "function";
const typeParameter = "parameter";
const typeParameterGlobal = "global parameter";
const typeParameterLinked = "linked parameter";
const typeParameterOutput = "output parameter";
const typeChoice = "choice";
const typeCondition = "condition";
const typeConditionAlias = "alias";
const typeConditionConstraint = "constraint";
const typeConditionAssignment = "assignment";

//--------------------------------------------------------------------------------

export const getTypeRoot = () => {
  return typeRoot;
};

export const getTypeFunction = () => {
  return typeFunction;
};

export const getTypeParameter = () => {
  return typeParameter;
};

export const getTypeParameterGlobal = () => {
  return typeParameterGlobal;
};

export const getTypeParameterLinked = () => {
  return typeParameterLinked;
};

export const getTypeParameterOutput = () => {
  return typeParameterOutput;
};

export const getTypeChoice = () => {
  return typeChoice;
};

export const getTypeCondition = () => {
  return typeCondition;
};

export const getTypeConditionAlias = () => {
  return typeConditionAlias;
};

export const getTypeConditionConstraint = () => {
  return typeConditionConstraint;
};

export const getTypeConditionAssignment = () => {
  return typeConditionAssignment;
};

//-----------------------------------------------------------------------------------

export const getExternalModelTypes = () => {
  return [
    getTypeFunction(),
    getTypeParameter(),
    getTypeChoice(),
    getTypeParameterLinked(),
    getTypeParameterOutput(),
  ]
}

export const getTypeSimplified = (type) => {
  if (isChoice(type)) return getTypeChoice();
  if (isParameter(type)) return getTypeParameter();
  if (isLogic(type)) return getTypeCondition();
  if (isFunction(type)) return getTypeFunction();
  if (isRoot(type)) return getTypeRoot();
  return null;
};

const isRoot = (type) => {
  return type === getTypeRoot();
};

const isLogic = (type) => {
  return (
    type === getTypeConditionAlias() ||
    type === getTypeConditionAssignment() ||
    type === getTypeConditionConstraint()
  );
};

const isFunction = (type) => {
  return type === getTypeFunction();
};

const isParameter = (type) => {
  return (
    type === getTypeParameter() ||
    type === getTypeParameterGlobal() ||
    type === getTypeParameterLinked() ||
    type === getTypeParameterOutput()
  );
};

const isChoice = (type) => {
  return type === getTypeChoice();
};
